// API Gateway paths
export const REVIEWS_API_PATH = '/api/review/v1';
export const CONNECT_API_PATH = '/api/connect/graphql';
export const MENTOR_API_PATH = '/api/mentor/v1/graphql';
export const PENSIEVE_API_PATH = '/api/pensieve/graphql';

// Other
export const UDS_GLYPH_URL = 'https://uds-assets.udacity.com/glyphs/v2/';
